import { Component, Inject, Input } from '@angular/core';
import { IEnvironmentService } from '../../../../services/environment/environment.interface';

@Component({
  selector: 'gtd-affiliate-pdf',
  template:
    '<div class="p500-ui-icon-pdf d-block text-center" style="cursor: pointer;" p500UITooltip tooltipData="Download PDF" (click)="downloadPDF()"></div>',
})
export class AffiliatePdfComponent {
  @Input() public data: any;
  private endpointApi: string;

  constructor(@Inject('IEnvironmentService') private envService: IEnvironmentService) {
    this.endpointApi = this.envService.getVar('services.api') as string;
  }

  downloadPDF(): void {
    const token = localStorage.getItem('tracking-token');
    const elementRef = document.createElement('a');
    if (this.data?.pdf) {
      elementRef.href = this.data.pdf;
      elementRef.target = '_blank';
    } else {
      elementRef.href = `${this.endpointApi}/invoice/generate-pdf/${this.data?.id}?token=${token}`;
    }
    elementRef.style.display = 'none';
    document.body.appendChild(elementRef);
    elementRef.click();
    document.body.removeChild(elementRef);
  }
}
